import styled from "styled-components";
import { Banner, NewButton, NewIcon, NewTypography } from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledThankYou = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledText = styled(NewTypography)`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  line-height: 29px;
`;

export const StyledTitle = styled(StyledText)`
  margin-top: 2.75rem;
`;

export const StyledSubtitle = styled(StyledText)`
  font-size: 14px;
  margin-top: 2rem;
`;

export const StyledBanner = styled(Banner)`
  margin-top: 3.875rem;
`;

export const StyledBannerText = styled(NewTypography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${theme.color.bannerText};
`;

export const StyledList = styled.ul`
  list-style-position: outside;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding-left: 1.5rem;
`;

export const StyledNewListItem = styled.li``;

export const StyledNewButton = styled(NewButton)`
  margin-top: 3.875rem;
`;

export const StyledNewIcon = styled(NewIcon)`
  svg {
    fill: ${theme.color.ctaActionLink};
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
`;
